import { NewSubTask } from 'shared/types/task';
import * as yup from 'yup';

const schema = yup
  .object<NewSubTask>({
    id: yup.string().required(),
    name: yup.string().required(),
  })
  .strip();

const arraySchema = yup.array().of(schema);

export const newSubTasksValidation = (subTasks: NewSubTask[]) =>
  arraySchema.validateSync(subTasks, { stripUnknown: true }) as
    | NewSubTask[]
    | undefined;
